import _defineProperty from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty"; //@ts-check

import React from 'react';
import cx from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import LinearProgress from '@material-ui/core/LinearProgress';
import MissingValue from '../MissingValue';
import { isSpecified } from '../util';
var useStyles = makeStyles(function (theme) {
  return {
    value: {
      marginRight: theme.spacing(1),
      minWidth: 25,
      display: 'inline-block',
      verticalAlign: 'middle',
      textAlign: 'center'
    },
    progress: {
      width: 120,
      height: 16
    },
    invalid: {
      '& $progress': {
        opacity: 0.2
      },
      '& $value': {}
    }
  };
}, {
  name: 'ECExperienceScore'
});
/**
 * @param {import('../types').FormatterProps<number>} props
 */

var ExperienceScore = function ExperienceScore(_ref) {
  var value = _ref.value,
      fallback = _ref.fallback;
  var classes = useStyles({});
  if (!isSpecified(value)) return fallback;
  var isValid = typeof value === 'number' && value >= 0 && value <= 100;
  /**@type {React.ReactNode} */

  var formattedValue = value;
  if (!isValid) formattedValue = React.createElement(MissingValue, null);
  return React.createElement(Grid, {
    container: true,
    direction: "row",
    alignItems: "center",
    className: cx(_defineProperty({}, classes.invalid, !isValid))
  }, React.createElement(Grid, {
    item: true
  }, React.createElement(Typography, {
    color: "inherit",
    className: classes.value
  }, formattedValue)), React.createElement(Grid, {
    item: true
  }, React.createElement(LinearProgress, {
    className: classes.progress,
    variant: "determinate",
    value: value
  })));
};

ExperienceScore.defaultProps = {
  fallback: React.createElement(MissingValue, null),
  color: '#FFF'
};
export default ExperienceScore;